import React from 'react'
import { Card, Input, Space, Button, Select } from 'antd'
import { SearchOutlined, PlusOutlined } from '@ant-design/icons'
import { useCommissions } from '../hooks/useCommissions'
import { useCommissionActions } from '../hooks/useCommissionActions'
import { CommissionsTable } from '../components/CommissionsTable'
import { CommissionDetailsDrawer } from '../components/CommissionDetailsDrawer'
import { CommissionFormModal } from '../components/CommissionFormModal'

export const CommissionsScreen: React.FC = () => {
    const {
        commissions,
        searchText, setSearchText,
        statusFilter, setStatusFilter,
        refetch
    } = useCommissions()

    const {
        selectedCommission,
        isDetailDrawerOpen,
        isFormModalOpen,
        editingCommission,
        handleViewDetails,
        handleAddCommission,
        handleEditCommission,
        handleDeleteCommission,
        handleFormSubmit,
        closeDrawer,
        closeFormModal
    } = useCommissionActions(refetch)

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                    <Space>
                        <Input
                            placeholder="Search commissions..."
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ width: 300 }}
                        />
                        <Select
                            value={statusFilter}
                            onChange={setStatusFilter}
                            style={{ width: 120 }}
                            options={[
                                { value: 'all', label: 'All Status' },
                                { value: 'active', label: 'Active' },
                                { value: 'inactive', label: 'Inactive' },
                            ]}
                        />
                    </Space>
                    <Button type="primary" icon={<PlusOutlined />} onClick={handleAddCommission}>
                        Add Commission
                    </Button>
                </div>

                <CommissionsTable
                    commissions={commissions}
                    onRowClick={handleViewDetails}
                    onEdit={handleEditCommission}
                    onDelete={handleDeleteCommission}
                />
            </Card>

            <CommissionDetailsDrawer
                commission={selectedCommission}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onEdit={handleEditCommission}
                onDelete={handleDeleteCommission}
            />

            <CommissionFormModal
                open={isFormModalOpen}
                onCancel={closeFormModal}
                onSubmit={handleFormSubmit}
                initialValues={editingCommission}
            />
        </Space>
    )
}
